import React from 'react';
import * as Flags from './flags';

export const heroData = {
  heading: "Raisin's platforms and markets",
  body: "Our website provides extensive coverage of different markets based on your country selection. Whether you're interested in savings, private equity, or deposits, we have the latest offers and insights to keep you on pulse. So choose your country and browse through opportunities.",
};

export const alertText =
  'Please select the country of your tax residence. Your tax residence is required for registration and financial transactions.';

export const markets = {
  'de-AT': {
    flag: <Flags.AtFlag />,
    country: 'Austria',
    link: 'https://www.weltsparen.at/',
    locale: 'de-AT',
    preferredLocale: 'de-at',
    redirectTarget: ['at', 'aut'],
  },
  'fi-FI': {
    flag: <Flags.FiFlag />,
    country: 'Finland',
    link: 'https://www.raisin.com/fi-fi/',
    locale: 'fi-FI',
    preferredLocale: 'fi-fi',
    redirectTarget: ['fi', 'fin'],
  },
  'fr-FR': {
    flag: <Flags.FrFlag />,
    country: 'France',
    link: 'https://www.raisin.com/fr-fr/',
    locale: 'fr-FR',
    preferredLocale: 'fr-fr',
    redirectTarget: ['fr', 'fra'],
  },
  'de-DE': {
    flag: <Flags.DeFlag />,
    country: 'Germany',
    link: 'https://www.weltsparen.de/',
    locale: 'de-DE',
    preferredLocale: 'de-de',
    redirectTarget: ['de', 'deu'],
  },
  'en-IE': {
    flag: <Flags.IeFlag />,
    country: 'Ireland',
    link: 'https://www.raisin.ie/',
    locale: 'en-IE',
    preferredLocale: 'en-ie',
    redirectTarget: ['ie', 'irl'],
  },
  'nl-NL': {
    flag: <Flags.NlFlag />,
    country: 'Netherlands',
    link: 'https://www.raisin.nl/',
    locale: 'nl-NL',
    preferredLocale: 'nl-nl',
    redirectTarget: ['nl', 'nld'],
  },
  'pl-PL': {
    flag: <Flags.PlFlag />,
    country: 'Poland',
    link: 'https://www.raisin.com/pl-pl/',
    locale: 'pl-PL',
    preferredLocale: 'pl-pl',
    redirectTarget: ['pl', 'pol'],
  },
  'es-ES': {
    flag: <Flags.EsFlag />,
    country: 'Spain',
    link: 'https://www.raisin.es/',
    locale: 'es-ES',
    preferredLocale: 'es-es',
    redirectTarget: ['es', 'esp'],
  },
  'en-GB': {
    flag: <Flags.GbFlag />,
    country: 'United Kingdom',
    link: 'https://www.raisin.co.uk/',
    locale: 'en-GB',
    preferredLocale: 'en-gb',
    redirectTarget: ['gb', 'gbr'],
  },
  us: {
    flag: <Flags.UsFlag />,
    country: 'United States',
    link: 'https://www.raisin.com/en-us/',
    locale: 'en-US',
    preferredLocale: 'en-us',
    redirectTarget: ['us', 'usa'],
  },
  en: {
    flag: <Flags.EuFlag />,
    country: 'Other (EU)',
    link: 'https://www.raisin.com/en/',
    locale: 'other',
    preferredLocale: 'en',
    redirectTarget: ['eu', 'eur'],
  },
};

export const metaTitle = 'Raisin – Choose your country';
export const metaDescription =
  'Choose your location to open an account with Raisin and benefit from top term deposits, savings accounts & investment products!';
export const canonicalLink = 'https://www.raisin.com/en/select-country/';
